import { get } from '../api';

export const BUILD_WATCHLIST_ADD = 'BUILD_WATCHLIST_ADD';
export const BUILD_WATCHLIST_REMOVE = 'BUILD_WATCHLIST_REMOVE';
export const FETCH_ONE_BUILD = 'FETCH_ONE_BUILD';
export const FETCH_ALL_BUILDS = 'FETCH_ALL_BUILDS';
export const FETCH_ALL_COUNTS = 'FETCH_ALL_COUNTS';

const BuildActions = {
  fetchOne: (buildId: number) => ({
    type: FETCH_ONE_BUILD,
    meta: {
      id: buildId,
    },
    async payload() {
      return get(`/api/builds/${buildId}`, true);
    },
  }),
  fetchAll: (filters: object) => ({
    type: FETCH_ALL_BUILDS,
    async payload() {
      return get(`/api/builds`, true, filters);
    },
  }),
  fetchAllCounts: (filters: object) => ({
    type: FETCH_ALL_COUNTS,
    async payload() {
      return get(`/api/counts/builds`, true, filters);
    },
  }),
  watchBuild: (buildId) => ({
    type: BUILD_WATCHLIST_ADD,
    payload: buildId,
  }),
  stopWatchingBuild: (buildId) => ({
    type: BUILD_WATCHLIST_REMOVE,
    payload: buildId,
  }),
};

export default BuildActions;
